import { render, staticRenderFns } from "./QuickAddProducts.vue?vue&type=template&id=544afb05"
import script from "./QuickAddProducts.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuickAddProducts.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./QuickAddProducts.vue?vue&type=style&index=0&id=544afb05&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports